<template>
	<v-container>
		<v-row>
			<v-col cols="12" sm="4" class="mx-2 mb-3 pr-4">
				<v-menu
					ref="menu"
					v-model="menu"
					:close-on-content-click="false"
					:return-value.sync="month"
					transition="scale-transition"
					offset-y
					min-width="290px"
				>
					<template v-slot:activator="{ on }">
						<v-text-field
							v-model="month"
							dense
							outlined
							filled
							readonly
							small
							label="Mes a trabajar"
							hide-details
							v-on="on"
						></v-text-field>
					</template>
					<v-date-picker
						v-model="month"
						outlined
						type="month"
						locale="es"
						no-title
						scrollable
					>
						<v-spacer></v-spacer>
						<v-btn text color="primary" @click="menu = false">Cancelar</v-btn>
						<v-btn text color="primary" @click="$refs.menu.save(month)">OK</v-btn>
					</v-date-picker>
				</v-menu>
			</v-col>
			<v-col cols="12" sm="6" offset-sm="3" class="text-center">
				<div v-if="invoice">
					<h4>Existe un estado de pago emitido el {{ date }}</h4>
					<br />
					<h3>
						ESTADO:
						<v-icon v-if="invoice.status == 'PAGADO'" color="success"
							>mdi-check-decagram</v-icon
						>
						<v-icon v-if="invoice.status == 'NO PAGADO'">mdi-cancel</v-icon>
						<v-icon v-if="invoice.status == 'REVISIÓN'" color="warning">
							mdi-clock-alert-outline
						</v-icon>
						{{ invoice.status }}
					</h3>
					<span
						v-if="invoice.status == 'NO PAGADO'"
						class="text-overline"
						style="color: red;"
					>
						<b>Suspensión de servicio programado: {{ dueDate }}</b>
					</span>
					<div v-if="invoice.status == 'NO PAGADO'">
						<h3 class="mb-2">Total a pagar ${{ invoice.mount }}</h3>
						<v-divider />
						<v-text-field
							id="rut-input"
							v-model.trim="$v.rutNotification.$model"
							dense
							outlined
							filled
							small
							class="mx-2 mb-1 mt-3 px-2"
							label="RUT que realizó pago"
							hint="Ej: 11222333-4"
							:error-messages="rutErrors"
							@input="$v.rutNotification.$touch()"
							@blur="$v.rutNotification.$touch()"
						></v-text-field>
						<v-btn
							:disabled="$v.rutNotification.$model == '' || rutErrors.length != 0"
							class="mb-3 px-2"
							color="success"
							:loading="loading"
							@click="sendPay()"
							>Notificar transferencia realizada.
						</v-btn>
					</div>
					<v-divider />
					<div v-if="invoice.status == 'NO PAGADO'" class="my-3">
						<v-btn color="success" :loading="loading" @click.stop="startTransaction"
							>Pagar por Mercado pago.
						</v-btn>
						<v-dialog v-model="dialogTrigger" max-width="290">
							<TransactionDialog
								:transaction-status="transactionStatus"
								:collection-id="collectionId"
							></TransactionDialog>
						</v-dialog>
					</div>
					<div v-else class="mb-2" style="color: green;">
						Muchas gracias
					</div>
					<v-divider />
				</div>
				<div v-else>
					<h3>No existe una factura para la fecha {{ date }}</h3>
				</div>
			</v-col>
		</v-row>
		<v-card v-if="invoice" outlined class="pl-2 mb-1" :class="globalBackground">
			<v-row>
				<v-col class="listPay text-left my-3">
					<h4>
						Personal registrado:
						<span v-if="invoice.persons">{{ invoice.persons.length }}</span>
					</h4>
					<div v-for="(person, index) in invoice.persons" :key="index">
						{{ person.rut ? person.rut : 'Sin rut' }}
						{{ person.firstName }}
						<div v-if="(1 + index) % billing.persons.perPerson == 0" class="acumulate">
							Acumulado: ${{
								(
									((index == 0 ? 0 : 1 + index) / billing.persons.perPerson) *
									billing.persons.cost
								).toFixed(0)
							}}
						</div>
					</div>
				</v-col>
				<v-col
					><h2>{{ howManyMissing.persons.total }}</h2>
					<span style="font-size: 12px;"
						>Cada {{ billing.persons.perPerson }} personas
						<h3>${{ billing.persons.cost }}</h3>
						Sin usar {{ howManyMissing.persons.missing }}</span
					>
				</v-col>
			</v-row>
		</v-card>
		<v-card v-if="invoice" outlined class="pl-2 mb-4 py-2" :class="globalBackground">
			<v-row>
				<v-col class="listPay text-left">
					<h4>
						Establecimientos registrados:
						<span v-if="invoice.places">{{ invoice.places.length }}</span>
					</h4>
					<div v-for="(place, index) in invoice.places" :key="index">
						{{ place.rut ? place.rut : 'Sin rut' }}
						{{ place.name }}
						<div v-if="(1 + index) % billing.places.perPlace == 0" class="acumulate">
							Acumulado: ${{
								(
									((index == 0 ? 0 : 1 + index) / billing.places.perPlace) *
									billing.places.cost
								).toFixed(0)
							}}
						</div>
					</div>
				</v-col>
				<v-col
					><h2>{{ howManyMissing.places.total }}</h2>
					<span style="font-size: 12px;">
						Cada {{ billing.places.perPlace }} establecimientos
						<h3>${{ billing.places.cost }}</h3>
						Sin usar {{ howManyMissing.places.missing }}</span
					>
				</v-col>
			</v-row>
		</v-card>
		<v-card v-if="invoice" outlined class="pl-2 mb-3" :class="globalBackground">
			<v-row>
				<v-col class="text-left">
					<h3 class="mb-2">Historial</h3>
					<div v-for="(inv, index) in invoices" :key="index">
						<div class="pointer mb-1" @click="setMonth(inv.month)">
							Estado de pago {{ inv.month }}:
							<b>
								<v-icon v-if="inv.status == 'PAGADO'" small color="success"
									>mdi-check-decagram</v-icon
								>
								<v-icon v-if="inv.status == 'REVISIÓN'" small color="warning">
									mdi-clock-alert-outline
								</v-icon>
								<v-icon v-if="inv.status == 'NO PAGADO'" small>mdi-cancel</v-icon>
								{{ inv.status }}
							</b>
							<div v-for="(log, index2) in inv.log" :key="index2" class="ml-2">
								{{ ' Info: ' + log }}
							</div>
						</div>
					</div>
				</v-col>
			</v-row>
		</v-card>
		<v-row>
			<v-col>
				<div class="spacerBottom" />
			</v-col>
		</v-row>
	</v-container>
</template>

<script>
import { mapActions, mapMutations } from 'vuex';
import { required, minLength, maxLength } from 'vuelidate/lib/validators';
import { validationMixin } from 'vuelidate';
import moment from 'moment';
import axios from '@/plugins/axios';

export default {
	name: 'Billing',
	components: {
		TransactionDialog: () => import('@/components/billings/TransactionDialog'),
	},
	mixins: [validationMixin],
	data() {
		return {
			rutNotification: '',
			monthDue: false,
			billing: {
				persons: {
					perPerson: 20,
					cost: 45000,
				},
				places: {
					cost: 45000,
					perPlace: 3,
				},
			},
			menu: false,
			month: null,
			invoice: null,
			invoices: [],
			dialogTrigger: false,
			transactionStatus: '',
			collectionId: 0,
			loading: false,
		};
	},
	computed: {
		rutErrors() {
			const errors = [];
			if (!this.$v.rutNotification.$dirty) return errors;
			!this.$v.rutNotification.required && errors.push('El RUT es querido');
			!this.$v.rutNotification.maxLength && errors.push('Máximo 12 caracteres');
			!this.$v.rutNotification.minLength && errors.push('Mínimo 10 caracteres');
			return errors;
		},
		date() {
			return moment(this.month).format('DD-MM-YYYY');
		},
		dueDate() {
			return moment(this.month)
				.add('45', 'days')
				.format('DD-MM-YYYY');
		},
		howManyMissing() {
			let personTotal = 0,
				personMissing = this.billing.persons.perPerson,
				placesTotal = 0,
				placesMissing = this.billing.places.perPlace;
			if (this.invoice) {
				if (this.invoice.persons)
					this.invoice.persons.forEach((p, index) => {
						let segment = (1 + index) % this.billing.persons.perPerson;
						if (segment == 0)
							personTotal =
								((index == 0 ? 0 : 1 + index) / this.billing.persons.perPerson) *
								this.billing.persons.cost;
						personMissing = this.billing.persons.perPerson - segment;
					});
				if (this.invoice.places)
					this.invoice.places.forEach((p, index) => {
						let segment = (1 + index) % this.billing.places.perPlace;
						if (segment == 0)
							placesTotal =
								((index == 0 ? 0 : 1 + index) / this.billing.places.perPlace) *
								this.billing.places.cost;
						placesMissing = this.billing.places.perPlace - segment;
					});
			}

			return {
				persons: {
					total: personTotal,
					missing: personMissing,
				},
				places: {
					total: placesTotal,
					missing: placesMissing,
				},
			};
		},
	},
	validations: {
		rutNotification: {
			required,
			minLength: minLength(10),
			maxLength: maxLength(12),
		},
	},
	watch: {
		month(newVal) {
			this.getInvoice(newVal);
		},
	},
	created() {
		this.month = moment()
			.date(1)
			.format('YYYY-MM');
		if (JSON.stringify(this.$router.history.current.query) !== '{}') {
			this.$router.replace({ name: 'billing', query: null });
		}
		const { transaction, collection_id } = this.$route.query;
		if (transaction && collection_id) {
			this.configTransactionDialog(transaction, collection_id);
		}
	},
	mounted() {
		this.getInvoice(this.month).catch(error =>
			this.snackbar({
				content: error.message,
				color: 'error',
			})
		);
	},
	methods: {
		sendPay() {
			this.patchInvoice({
				id: this.invoice._id,
				status: 'REVISIÓN',
				log:
					moment().format('DD-MM-YYYY') +
					': Se solicito revisión con rut ' +
					this.rutNotification,
			}).then(invoice => {
				if (invoice.status == 'REVISIÓN') {
					this.invoices = [];
					this.invoice = null;
					this.getInvoice(this.month);
				}
			});
		},
		setMonth(month) {
			this.month = moment(month).format('YYYY-DD-MM');
		},
		async getInvoice(newVal) {
			const actualMonth = moment(newVal)
				.date(1)
				.format('DD-MM-YYYY');
			const invoices = await this.fetchInvoice();
			this.invoices = invoices.invoice;
			this.invoice = invoices.invoice.filter(
				i => i.month == moment(actualMonth).format('MM-DD-YYYY')
			)[0];
			if (this.invoice) this.monthDue = true;
			else this.monthDue = false;
		},
		async startTransaction() {
			try {
				this.loading = true;
				const response = await this.startMercadoPagoPaymentFlow();
				window.location.href = response.preferenceUrl;
			} catch (e) {
				this.loading = false;
				this.snackbar({
					content: 'No fue posible iniciar la transacción, intente nuevamente',
					color: 'error',
				});
			}
		},
		async startMercadoPagoPaymentFlow() {
			return await axios(`/transactions/mercadopago/unlock/transaction/start`, {
				method: 'get',
			});
		},
		configTransactionDialog(transaction, collectionId) {
			this.transactionStatus = transaction;
			this.collectionId = collectionId;
			this.dialogTrigger = true;
		},
		...mapActions({
			patchInvoice: 'User/patchInvoice',
			fetchInvoice: 'User/fetchInvoice',
		}),
		...mapMutations({
			snackbar: 'Snackbar/showMessage',
		}),
	},
};
</script>

<style scoped>
.backgroundPlacesPersons {
	background-color: #6a31ff33;
	border-left: 5px solid #6a31ff;
}

.acumulate {
	text-align: center;
	padding-top: 10px;
	padding-bottom: 10px;
	background-color: #6a31ff33;
	margin-bottom: 10px;
	margin-top: 10px;
}

.listPay {
	overflow-y: auto;
	max-height: 150px;
}
</style>
